import cloneDeep from 'clone-deep'
import { InputType } from 'config'

export function buildFormState(
  inputDefs: Record<string, InputType>,
  valueOverrides: Record<string, any> = {},
): Record<string, InputType> {
  const next = cloneDeep(inputDefs)
  for (const key of Object.keys(valueOverrides)) {
    if (next[key]) (next[key] as any).value = valueOverrides[key]
  }
  return next
}
